<template>
  <div style="display: flex; flex-direction: column">
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        style="max-height: 100%"
      >
        <el-table-column prop="user" label="用户帐号" />
        <el-table-column
          prop="fDate"
          label="登录时间"
          :formatter="dateFormat"
        />
        <el-table-column
          prop="fOperationDate"
          label="最后访问时间"
          :formatter="dateFormat"
        />
        <el-table-column prop="onLineTimes" label="在线时间(分钟)" />
        <el-table-column prop="fIp" label="IP地址" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <ConfirmButton
                v-if="kickState"
                @confirm="_kick(scope.row)"
              >踢出</ConfirmButton>
            </template>
            <el-button
              size="mini"
              type="text"
              @click="readIP(scope.row)"
            >IP查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import ConfirmButton from '@components/ConfirmButton'

import moment from 'moment'
// import EditForm from './EditForm'

export default {
  components: {
    // EditForm
    ConfirmButton
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      tableData: [],
      loading: false,
      currentEditItem: null,
      kickState: true
    }
  },
  mounted() {
    this.refresh()

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '001006002') {
        this.kickState = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost(
        'SystemApplication/UserOnlin/UserOnLineEntry',
        this.query
      ).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }

        this.tableData = res.datalist.dataEntry
        this.pageRecordTotal = res.datalist.total
      })
        .finally(() => this.loading = false)
    },
    _kick(row) {
      //   console.log(row);
      this.$httpPost('SystemApplication/UserOnlin/KillUser', {
        killToken: row.fToken
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    readIP(row) {
      // console.log(row, 'row')
      window.open(row.ipUrl)
    },

    //    日期格式转换
    dateFormat: function(row, column, cellValue) {
      const date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
